// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.theme-picker .el-color-picker__trigger {\n    vertical-align: middle;\n}\n.theme-picker-dropdown .el-color-dropdown__link-btn {\n    display: none;\n}\n", ""]);
// Exports
module.exports = exports;
